// firebase.ts
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your Firebase configuration object (replace with your values from Firebase Console)
const firebaseConfig = {
    apiKey: "AIzaSyBzHlum04dQcpw2CRMrUc6CI-nkqYITO8g",
    authDomain: "gymgress-e1db5.firebaseapp.com",
    projectId: "gymgress-e1db5",
    storageBucket: "gymgress-e1db5.appspot.com",
    messagingSenderId: "430916898243",
    appId: "1:430916898243:web:1adb69fedf899bb1b50176",
    measurementId: "G-N1L7CH5T51"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and Firestore
const auth = getAuth(app);
const firestore = getFirestore(app);

export { auth, firestore };